import React from 'react';

function DisplayHTML({ htmlContent, classNames }) {
  return (
    <div className={classNames} style={{overflow: "auto"}}  dangerouslySetInnerHTML={{__html: htmlContent.replace(/href/g, "target='_blank' href")}}/>
  );
}

export default DisplayHTML;